var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('button-action',{attrs:{"title":_vm.title,"active":_vm.active}}),_c('input',{attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple,"disabled":!_vm.active},on:{"change":_vm.chooseFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }